import { makeStyles } from "@material-ui/core";

const useSignableDocumentsFullScreenEditorStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#53B3EA",
  },
  content: {
    padding: theme.spacing(2),
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  editor: {
    flex: 1,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
  },
  infoText: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  tabsContainer: {
    backgroundColor: theme.palette.background.default,
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
  },
  tabsWrapper: {
    flex: 1,
  },
  previewContainer: {
    flex: 1,
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: "#fff",
  },
  htmlPreview: {
    width: "100%",
    height: "100%",
  },
}));

export default useSignableDocumentsFullScreenEditorStyles;